import RegisterInterestModal from "./RegisterInterestModal";

export default RegisterInterestModal;
